export default __webpack_public_path__ + "static/PM_snake-7261ad41c202f1ac62618ae327beb6ad.png";